
import { gql } from "graphql-tag";
import { mapState, mapGetters } from "vuex";
import ClickOutside from "vue-click-outside";
import { PAGE_TYPE, QUERY_BEDBUILDER } from "./-index.query";
import { seoMixin, pageMixin } from "~/mixins";

const UID = "bedbuilder";

const BEDBUILDER_CORE_OPTIONS_QUERY = gql`
  query bedbuilder_core_options($uid: String!, $lang: String = "en-in") {
    bedbuilder_core_options(uid: $uid, lang: $lang) {
      base {
        name
        colours
        materials
      }
      headboard {
        name
        colours
        materials
        drawers
      }
      colours {
        name
        colour
      }
    }
  }
`;

export default {
  directives: { ClickOutside },

  mixins: [seoMixin, pageMixin],

  async asyncData({ app, error } = { query: {} }) {
    try {
      const { [PAGE_TYPE]: data } = await app.$prismicGql.request({
        query: QUERY_BEDBUILDER,
        variables: { uid: UID },
      });

      return {
        title: data.title,
        uid: UID,
        pageType: PAGE_TYPE,
        metaTitle: data.metaTitle,
        metaDescription: data.metaDescription,
        metaRobots: data.metaRobots,
        metaFields: { _linkType: data._linkType, _meta: data._meta },
      };
    } catch (err) {
      app.$bugsnag.notify(err);
      const message = "Oops Something went wrong...";
      return error({ statusCode: 500, message });
    }
  },

  data: () => ({
    selectedVariant: null,
    showSummary: false,
    showShareOptions: false,
    isOptionsChanged: false,
  }),

  async fetch() {
    const data = await this.$prismicGql.request({
      query: BEDBUILDER_CORE_OPTIONS_QUERY,
      variables: { uid: "bedbuilder-core-options" },
    });

    if (!data?.bedbuilder_core_options) {
      return;
    }

    this.$bedbuilder.processAvailableOptions(data?.bedbuilder_core_options);

    this.$store.dispatch("bedbuilder/setActiveOptions", this.selectedOptions);
    this.$router.push({
      path: this.$route.path,
      query: this.selectedOptions,
    });
  },

  fetchOnServer: false,

  computed: {
    ...mapState("bedbuilder", [
      "availableOptions",
      "showBedBuilderReset",
      "showBedBuilderShareOptions",
      "isGeneratingPDF",
      "activeImagesBase64",
      "headerBase64",
    ]),
    ...mapGetters("bedbuilder"),
    productImage() {
      return (
        this.selectedVariant?.image ??
        this.selectedVariant?.product.featuredImage
      );
    },
    selectedOptions() {
      return Object.fromEntries(
        Object.entries(this.$bedbuilder.defaultOptions).map(
          ([key, defaultValue]) => [key, this.$route.query[key] || defaultValue]
        )
      );
    },
    isDefaultOptionsChanged() {
      return Object.entries(this.$bedbuilder.defaultOptions).some(
        ([key, defaultValue]) => {
          return this.$route.query[key] !== defaultValue;
        }
      );
    },
    disablePreview() {
      return (
        this.isGeneratingPDF || !this.activeImagesBase64 || !this.headerBase64
      );
    },
  },

  watch: {
    "$route.query"() {
      this.$fetch();
    },
  },

  methods: {
    handleSummaryOuterClick() {
      this.showSummary = false;
    },
    handleShareOuterClick() {
      this.showShareOptions = false;
    },
    handleReset() {
      if (!this.isDefaultOptionsChanged) return;
      this.$store.dispatch("bedbuilder/openBedbuilderReset");
    },
    handlePrint() {
      if (this.disablePreview) return;
      this.$refs.bedbuilderPrint.printPreview();
    },
  },
};
